import { z } from 'zod';

/** State schema. */
export const stateVMSchema = z.object({
  name: z.string(),
  abbreviation: z.string(),
});

/** State. */
export type StateVM = z.infer<typeof stateVMSchema>;

/** Address schema. */
export const addressVMSchema = z.object({
  city: z.string(),
  state: stateVMSchema,
  addressLine1: z.string(),
  addressLine2: z.string(),
  country: z.string(),
});

/** Address. */
export type AddressVM = z.infer<typeof addressVMSchema>;

/** Initial values. */
export const addressInitial: AddressVM = {
  addressLine1: '',
  addressLine2: '',
  city: '',
  country: '',
  state: {
    name: '',
    abbreviation: '',
  },
};
